import { OVERVIEW_EVENTS } from '@utils/enums';
import { SubstituteEventAway } from '@components/StatsConsole/Widgets/OverviewWidget/parts/SubstituteEventAway';
import { SubstituteEventHome } from '@components/StatsConsole/Widgets/OverviewWidget/parts/SubstituteEventHome';
import MatchEventGoalHome from '@components/StatsConsole/Widgets/OverviewWidget/parts/MatchEventGoalHome';
import MatchEventGoalAway from '@components/StatsConsole/Widgets/OverviewWidget/parts/MatchEventGoalAway';
import { CommonEventHeightHome, CommonEventHeightAway } from './parts/CommonEventHeight';
import CommonSubHeader from '@components/StatsConsole/Widgets/OverviewWidget/parts/CommonSubHeader';
import { VAREventsHeightHome } from '@components/StatsConsole/Widgets/OverviewWidget/parts/VAREventsHeightHome';
import { VAREventsHeightAway } from '@components/StatsConsole/Widgets/OverviewWidget/parts/VAREventsHeightAway';
import MatchEventPenaltiesHome from '@components/StatsConsole/Widgets/OverviewWidget/parts/MatchEventPenaltiesHome';
import MatchEventPenaltiesAway from '@components/StatsConsole/Widgets/OverviewWidget/parts/MatchEventPenaltiesAway';
import AddedTimeBar from '@components/StatsConsole/Widgets/OverviewWidget/parts/AddedTimeBar';
import MatchEventPenaltyHome from './parts/MatchEventPenaltyHome';
import MatchEventPenaltyAway from './parts/MatchEventPenaltyAway';

interface MatchClockData {
    minutes: number;
    seconds: number;
    isRunning: boolean;
    formattedTime: string | null;
    currentPeriod: number;
    time_start: string;
    isEnded?: boolean;
    isExtraTimeFirstHalf: boolean;
    isExtraTimeSecondHalf: boolean;
    isHalfTimeOfExtraTime: boolean;
    isFullTime: boolean;
    isHalfTime: boolean;
    isPenalties: boolean;
    isPreMatch: boolean;
    isEndOfSecondHalf: boolean;
    isEndOfExtraTime: boolean;
    minute: number;
}

interface IOverviewWidgetProps {
    overviewDataSorted: any;
    isHalfTimeFirstEvent: boolean;
    isFullTimeFirstEvent: boolean;
    isExtraTimeFirstEvent: boolean;
    isPenaltiesFirstEvent: boolean;
    isMVP?: boolean;
    matchTime?: MatchClockData ;
}

const addOneMinuteToTime = (time: string) => {
    return (parseInt(time) + 1).toString();
};

const OverviewWidget = ({ 
    overviewDataSorted, 
    isMVP = true,
    isHalfTimeFirstEvent, 
    isFullTimeFirstEvent, 
    isExtraTimeFirstEvent, 
    isPenaltiesFirstEvent, 
    matchTime,
}: IOverviewWidgetProps) => {

    return (
            <div className='w-full pt-[32px]'>
                {overviewDataSorted?.match_events?.map((event: any, index: any) => {
                    let et = event.event_type;
                    let time = addOneMinuteToTime(event.match_time);
                    if (et === OVERVIEW_EVENTS.GOAL || et === OVERVIEW_EVENTS.OWN_GOAL) {
                        if (event.team === "HOME") {
                            return (
                                <MatchEventGoalHome
                                    key={index}
                                    home_score={event.home_score}
                                    away_score={event.away_score}
                                    time={time}
                                    goalscorer={event.goalscorer ?? event.player}
                                    assistant={event.assistant}
                                    event_type={et}
                                    isPlusSignNeeded={event.isTimePlusNeeded}
                                />
                            );
                        } else if (event.team === "AWAY") {
                            return (
                                <MatchEventGoalAway
                                    key={index}
                                    home_score={event.home_score}
                                    away_score={event.away_score}
                                    time={time}
                                    goalscorer={event.goalscorer ?? event.player}
                                    assistant={event.assistant}
                                    event_type={et}
                                    isPlusSignNeeded={event.isTimePlusNeeded}
                                />
                            );
                        }
                    } else if (et === OVERVIEW_EVENTS.PENALTY_GOAL) {
                        if (event.team === "HOME") {

                            return (
                                <MatchEventPenaltyHome
                                    key={index}
                                    home_score={event.home_score}
                                    away_score={event.away_score}
                                    goalscorer={event.goalscorer ?? event.player}
                                    event_type={et}
                                    time={time}
                                    isPlusSignNeeded={event.isTimePlusNeeded}
                                />
                            );
                        } else if (event.team === "AWAY") {
                            return (
                                <MatchEventPenaltyAway
                                    key={index}
                                    home_score={event.home_score}
                                    away_score={event.away_score}
                                    goalscorer={event.goalscorer ?? event.player}
                                    event_type={et}
                                    time={time}
                                    isPlusSignNeeded={event.isTimePlusNeeded}
                                />
                            );
                        }

                    } else if (et === OVERVIEW_EVENTS.PENALTIES_GOAL || et === OVERVIEW_EVENTS.PENALTIES_MISSED || et === OVERVIEW_EVENTS.PENALTIES_SAVED   ) {
                        if (event.team === "HOME") {

                            return (
                                <MatchEventPenaltiesHome
                                    key={index}
                                    home_score={event.home_score}
                                    away_score={event.away_score}
                                    goalscorer={event.goalscorer ?? event.player}
                                    event_type={et}
                                />
                            );
                        } else if (event.team === "AWAY") {
                            return (
                                <MatchEventPenaltiesAway
                                    key={index}
                                    home_score={event.home_score}
                                    away_score={event.away_score}
                                    goalscorer={event.goalscorer ?? event.player}
                                    event_type={et}
                                />
                            );
                        }

                    } else if (
                        et === OVERVIEW_EVENTS.PENALTY_SAVED ||
                        et === OVERVIEW_EVENTS.YELLOW_CARD ||
                        et === OVERVIEW_EVENTS.RED_CARD ||
                        et === OVERVIEW_EVENTS.OFFSIDE ||
                        et === OVERVIEW_EVENTS.CORNER ||
                        et === OVERVIEW_EVENTS.INJURY_BREAK ||
                        et === OVERVIEW_EVENTS.SECOND_YELLOW_CARD
                    ) {
                        if (event.team === "HOME") {
                            return (
                                <CommonEventHeightHome
                                    key={index}
                                    event_type={et}
                                    player={event.player}
                                    label={event.label}
                                    team={event.team}
                                    time={time}
                                    height='34'
                                    isPlusSignNeeded={event.isTimePlusNeeded}
                                />
                            );
                        } else if (event.team === "AWAY") {
                            return (
                                <CommonEventHeightAway
                                    key={index}
                                    event_type={et}
                                    player={event.player}
                                    label={event.label}
                                    team={event.team}
                                    time={time}
                                    height='34'
                                    isPlusSignNeeded={event.isTimePlusNeeded}
                                />
                            );
                        }
                    } else if (et === OVERVIEW_EVENTS.SUBSTITUTE) {
                        if (event.team === "HOME") {
                            return (
                                <SubstituteEventHome
                                    key={index}
                                    player_out={event.player_out}
                                    player_in={event.player_in}
                                    event_type={et}
                                    time={time}
                                    isPlusSignNeeded={event.isTimePlusNeeded}

                                />
                            );
                        } else if (event.team === "AWAY") {
                            return (
                                <SubstituteEventAway
                                    key={index}
                                    player_out={event.player_out}
                                    player_in={event.player_in}
                                    event_type={et}
                                    time={time}
                                    isPlusSignNeeded={event.isTimePlusNeeded}
                                />
                            );
                        }
                    } else if (et === OVERVIEW_EVENTS.HALF_TIME) {
                        return (
                            <CommonSubHeader
                                key={index}
                                home_score={event.home_score}
                                away_score={event.away_score}
                                isFirstEvent={isHalfTimeFirstEvent}
                                eventType={et}

                            />
                        );
                    } else if (et === OVERVIEW_EVENTS.FULL_TIME) {
                        return (
                            <CommonSubHeader
                                key={index}
                                home_score={event.home_score}
                                away_score={event.away_score}
                                isFirstEvent={isFullTimeFirstEvent}
                                eventType={et}
                            />
                        );
                    } else if (et === OVERVIEW_EVENTS.EXTRA_TIME) {
                        return (
                            <CommonSubHeader
                                key={index}
                                home_score={event.home_score}
                                away_score={event.away_score}
                                isFirstEvent={isExtraTimeFirstEvent}
                                eventType={et}
                            />
                        );
                    } else if (et === OVERVIEW_EVENTS.PENALTIES) {
                        return (
                            <CommonSubHeader
                                key={index}
                                home_score={event.home_score}
                                away_score={event.away_score}
                                isFirstEvent={isPenaltiesFirstEvent}
                                eventType={et}
                            />
                        );
                    } else if (et === OVERVIEW_EVENTS.PENALTY_MISSED ||
                        et === OVERVIEW_EVENTS.SHOT_ON_THE_TARGET ||
                        et === OVERVIEW_EVENTS.SHOT_OFF_THE_TARGET ||
                        et === OVERVIEW_EVENTS.PENALTY_AWARDED) {
                        if (event.team === "HOME") {
                            return (
                                <CommonEventHeightHome
                                    key={index}
                                    event_type={et}
                                    player={event.player}
                                    team={event.team}
                                    time={time}
                                    height='32'
                                    isPlusSignNeeded={event.isTimePlusNeeded}
                                />
                            );
                        } else if (event.team === "AWAY") {
                            return (
                                <CommonEventHeightAway
                                    key={index}
                                    event_type={et}
                                    player={event.player}
                                    team={event.team}
                                    time={time}
                                    height='32'
                                    isPlusSignNeeded={event.isTimePlusNeeded}
                                />
                            );
                        }
                    } else if (!isMVP && (et === OVERVIEW_EVENTS.VAR || et === OVERVIEW_EVENTS.VAR_CHECK || et === OVERVIEW_EVENTS.VAR_DECLINED)) {
                        if (event.team === "HOME") {
                            return (
                                <VAREventsHeightHome
                                    key={index}
                                    event_type={et}
                                    player={event.player}
                                    team={event.team}
                                    time={time}
                                    height='33'
                                    isDescBold={true}
                                    description={event.description}
                                    isPlusSignNeeded={event.isTimePlusNeeded}
                                />
                            );
                        } else if (event.team === "AWAY") {
                            return (
                                <VAREventsHeightAway
                                    key={index}
                                    event_type={et}
                                    player={event.player}
                                    team={event.team}
                                    time={time}
                                    height='33'
                                    isDescBold={true}
                                    description={event.description}
                                    isPlusSignNeeded={event.isTimePlusNeeded}
                                />
                            );
                        }
                    } else if (et === OVERVIEW_EVENTS.ADDED_TIME) {
                        return (
                            <AddedTimeBar
                                key={index}
                                minutes={event.minutes}
                            />
                        );
                    }
                    return null;
                })}
            </div>
    )
}

export default OverviewWidget;